
import jsPDF from 'jspdf';
import { EnviarCorreopdf } from '../../Componentes/FunctionLogin'
import cabeceraImage from './../../recursos/cabecera.png';


export async function generatePDF(tableData, valorCalificacion, firma, codigoInternoProveedor, nombreProveedor, tipoDocumento, numeroDocumento, direccion, prestadorBienesServicios,
    evaluador, cargo, categoria, fechaEvaluacion, periodoEvaluado, correoProveedor, responsableVisita, observacion, firmaFile2, responsableRecibir, sendEmail = false) {
    return new Promise((resolve) => {
        const doc = new jsPDF({
            orientation: 'landscape', // Configura la orientación del PDF como horizontal
        });

        doc.addImage(cabeceraImage, 'JPEG', 5, 5, 287, 50); // Ajusta las coordenadas y dimensiones

        // Agrega el contenido línea por línea

        doc.setFontSize(10);
        doc.cell(5, 55, 200, 13, 'SUPPLIER QUALITY EVALUATION', 0);
        doc.cell(5, 55, 87, 13, 'Code: F-CS-CP-05 \nVersion: 07', 0);

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Sets the background color to light gray (RGB: 245, 245, 245)
        doc.rect(5, 70, 287, 9, 'FD'); // Draws a rectangle with the background color
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('SUPPLIER IDENTIFICATION', 150, 75, 'center');

        doc.setFont('', '');

        //------------------------------------------------------------------------------------------------


        var tablaCampos = [
            { nombre: "INTERNAL SUPPLIER CODE", value: codigoInternoProveedor, nombre1: "SUPPLIER NAME", value1: nombreProveedor },
            { nombre: "DOCUMENT TYPE", value: tipoDocumento, nombre1: "DOCUMENT NUMBER", value1: numeroDocumento },
            { nombre: "ADDRESS", value: direccion, nombre1: "GOODS OR SERVICES PROVIDER", value1: prestadorBienesServicios },
            { nombre: "EVALUATOR", value: evaluador, nombre1: "POSITION", value1: cargo },
            { nombre: "CATEGORY", value: categoria, nombre1: "EVALUATION DATE", value1: fechaEvaluacion },
            { nombre: "EVALUATED PERIOD", value: periodoEvaluado, nombre1: "SUPPLIER EMAIL", value1: correoProveedor }
        ]
            ;

        var yContactoRetangulo = 84, yTexto = 87;
        tablaCampos.forEach(element => {


            var nombrev2 = doc.splitTextToSize(element.nombre, 50);
            doc.setFont('', '');
            doc.setFontSize(10);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(5, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(nombrev2, 6, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var valuev2 = doc.splitTextToSize(element.value, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(80, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(5, 0, 0); // Establece el color del texto en negro
            doc.text(valuev2, 81, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var nombre1v2 = doc.splitTextToSize(element.nombre1, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(160, yContactoRetangulo, 80, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(nombre1v2, 161, yTexto, 'left');
            //-----

            doc.setFontSize(10);
            var value1v2 = doc.splitTextToSize(element.value1, 50);
            doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(240, yContactoRetangulo, 52, 12, 'FD'); // Dibuja un rectángulo con el color de fondo para el segundo texto
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(value1v2, 241, yTexto, 'left');
            yContactoRetangulo = yContactoRetangulo + 12;
            yTexto = yTexto + 12;
        });

        //------------------------------------------------------------------------------------------------

        yContactoRetangulo = yContactoRetangulo + 10;
        yTexto = yTexto + 14;

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245);
        doc.rect(35, (yContactoRetangulo + 1), 90, 14, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('SCORING SYSTEM', (35 + 1), (yTexto), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(90, (yContactoRetangulo + 1), 40, 7, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('1', (90 + 18), (yTexto - 3), 'left');
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(90, (yContactoRetangulo + 1 + 7), 40, 7, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('2', (90 + 18), (yTexto + 5), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(130, (yContactoRetangulo + 1), 40, 7, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('Does not comply', (130 + 7), (yTexto - 3), 'left');
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(130, (yContactoRetangulo + 1 + 7), 40, 7, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('Partially complies', (130 + 7), (yTexto + 5), 'left');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(170, (yContactoRetangulo + 1), 40, 14, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('3', (170 + 18), (yTexto), 'justify');

        doc.setFont('', '');
        doc.setFillColor(255, 255, 255);
        doc.rect(210, (yContactoRetangulo + 1), 40, 14, 'FD'); // Draws a rectangle with the background color for the second text
        doc.setTextColor(0, 0, 0); // Sets the text color to black
        doc.text('Complies', (210 + 15), (yTexto), 'justify');

        doc.addPage()
        yContactoRetangulo = 10;
        yTexto = 15;


        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 256.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('QUALIFICATION PARAMETERS', 6, yTexto, 'left');
        //---------
        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(256.7, yContactoRetangulo, 36, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('QUALIFICATION', 257.7, yTexto, 'left');
        //--------

        const pageHeight = doc.internal.pageSize.getHeight(); // Obtén el ancho de la página



        var textoTablaPreguntas = yTexto;
        var RetanguloPreguntas = yContactoRetangulo;
        tableData.forEach(elementv1 => {
            textoTablaPreguntas = textoTablaPreguntas + 9;
            RetanguloPreguntas = RetanguloPreguntas + 9;
            doc.setFont('', 'bold');
            doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
            doc.rect(5, RetanguloPreguntas, 287.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
            doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
            doc.text(elementv1.category, 6, textoTablaPreguntas - 1, 'left');

            textoTablaPreguntas = textoTablaPreguntas + 9;
            RetanguloPreguntas = RetanguloPreguntas + 9;

            elementv1.questions.forEach(element => {
                var evaluation = doc.splitTextToSize(element.evaluation, 200);
                var textLines = doc.splitTextToSize(element.question, 200);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 256.7, (textLines.length == 1 ? 17 : (textLines.length / 3) * 15), 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(textLines, 5, textoTablaPreguntas, 'left');


                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(257.7, RetanguloPreguntas, 35, (textLines.length == 1 ? 17 : (textLines.length / 3) * 15), 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${evaluation}`, 273, textoTablaPreguntas + 2, 'center');


                RetanguloPreguntas = RetanguloPreguntas + (textLines.length == 1 ? 15 : (textLines.length / 3) * 17);
                textoTablaPreguntas = textoTablaPreguntas + (textLines.length == 1 ? 15 : (textLines.length / 3) * 17);

                doc.setFontSize(10)
                if (RetanguloPreguntas >= 170) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

            })
        });

        yContactoRetangulo = RetanguloPreguntas;
        yTexto = textoTablaPreguntas + 5;
        yContactoRetangulo = yContactoRetangulo + 5;
        yTexto = yTexto + 2;

        doc.setFont('', 'bold');
        doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 286.7, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text('COMMENT', 150, yTexto, 'center');

        yContactoRetangulo = yContactoRetangulo + 9;
        yTexto = yTexto + 9;

        var observaciontext = doc.splitTextToSize(observacion, 290);
        doc.setFont('', '');
        doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
        doc.rect(5, yContactoRetangulo, 286.7, (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16), 'FD'); // Dibuja un rectángulo con el color de fondo
        doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
        doc.text(observaciontext, 6, yTexto, 'left');

        yContactoRetangulo = yContactoRetangulo + (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16);
        yTexto = yTexto + (observaciontext.length == 1 ? 15 : (observaciontext.length / 3) * 16);
        textoTablaPreguntas = yTexto;
        RetanguloPreguntas = yContactoRetangulo;

        doc.setFontSize(10)
        if (RetanguloPreguntas >= 180) {
            doc.addPage()
            textoTablaPreguntas = 5;
            RetanguloPreguntas = 0;
        }

        var tablafinal = [1, 2, 3, 4, 5];
        tablafinal.forEach(element => {
            if (element == 1) {
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 5;
                RetanguloPreguntas = RetanguloPreguntas + 5;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(60, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Business Associate Evaluation', 61, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(210, RetanguloPreguntas, 70, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${valorCalificacion} %`, 212, textoTablaPreguntas, 'left');
            } else if (element == 2) {

                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 10;
                RetanguloPreguntas = RetanguloPreguntas + 10;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(60, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('QUALIFICATION', 61, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                (valorCalificacion > 80 ? doc.setFillColor(51, 162, 23) : valorCalificacion > 60 && valorCalificacion <= 80 ? doc.setFillColor(255, 255, 0) : doc.setFillColor(255, 0, 0))
                // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(210, RetanguloPreguntas, 70, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${(valorCalificacion > 80 ? "FAVORABLE" : valorCalificacion > 60 && valorCalificacion <= 80 ? "CONDITIONAL FAVORABLE" : "NOT FAVORABLE")} `, 212, textoTablaPreguntas, 'left');
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

            } else if (element == 3) {
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 20;
                RetanguloPreguntas = RetanguloPreguntas + 20;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('TYPE OF BUSINESS ASSOCIATION', 6, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('SCORE', 76, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('ACTION TO FOLLOW', 116, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('CONTROL', 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('FAVORABLE', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 80 ', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("Emphasize the strong points so that they maintain the position and the not so strong points so that they improve.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas - 2, 'left');

                var texto2 = doc.splitTextToSize("No verification required", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('No verification required', 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 14;
                RetanguloPreguntas = RetanguloPreguntas + 14;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('CONDITIONAL FAVORABLE', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 60  Y <=80', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("Present weak points so you can implement actions.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas, 'left');

                var texto2 = doc.splitTextToSize("Eventual verification after three months", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 14, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto2, 221, textoTablaPreguntas, 'left');

                //--------------------------------------------------------------------------------------------------
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 14;
                RetanguloPreguntas = RetanguloPreguntas + 14;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 75, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('NOT FAVORABLE', 6, textoTablaPreguntas, 'left');

                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 40, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('> 0  Y <=60', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');

                var texto1 = doc.splitTextToSize("The associate is informed that he has not met the expected parameters to continue having his services NOT FAVORABLE.", 70);
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(115, RetanguloPreguntas, 105, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto1, 116, textoTablaPreguntas, 'left');

                var texto2 = doc.splitTextToSize("Study the action plans sent by the supplier.", 70);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(220, RetanguloPreguntas, 72, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(texto2, 221, textoTablaPreguntas, 'left');

            } else if (element == 4) {

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                /* doc.setFont('', 'bold');
                 doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                 doc.rect(0, 91, 300, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                 doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                 doc.text(`PRODUCTO O SERVICIOS QUE SUMINISTRA A LA EMPRESA: ${select}`, 1, 98, 'left');*/


                textoTablaPreguntas = textoTablaPreguntas + 25;
                RetanguloPreguntas = RetanguloPreguntas + 25;

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                var politicas = doc.splitTextToSize("The company CI TECNOLOGÍA ALIMENTARIA S.A.S “CI TALSA” is a legally constituted commercial company with its main address at Carrera 50 GG Nº 12 Sur 83 of the municipality of Itagüí, department of Antioquia, Republic of Colombia and to comply with the provisions of the Law 1581 of 2012, regulated by Decree No. 1377 of 2013, relating to the protection of personal data, issues the following regulations for its proper treatment, in compliance with the legal regulations and the philosophy of our society. For more information, go to the following link: https://www.citalsa.com/pages/politica-para-el-tratamiento-de-datos-personales", 290);
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 300, (80), 'F'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(politicas, 6, textoTablaPreguntas, 'left');

                if (RetanguloPreguntas >= 140) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }


                textoTablaPreguntas = textoTablaPreguntas + 20;
                RetanguloPreguntas = RetanguloPreguntas + 20;
                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('RESPONSIBLE FOR EVALUATION', 6, textoTablaPreguntas, 'left');

                doc.setFont('', 'bold');
                doc.setFillColor(245, 245, 245); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(150, RetanguloPreguntas, 142, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('RESPONSIBLE FOR EVALUATION', 151, textoTablaPreguntas, 'left');




                //-----

                //-----------------------------------------------------
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }

                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(5, RetanguloPreguntas, 150, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${responsableVisita}`, 6, textoTablaPreguntas, 'left');

                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(150, RetanguloPreguntas, 142, 9, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text(`${responsableRecibir}`, 151, textoTablaPreguntas, 'left');
                //-----



                textoTablaPreguntas = textoTablaPreguntas + 9;
                RetanguloPreguntas = RetanguloPreguntas + 9;
                doc.addImage(firma, 'JPEG', 0, RetanguloPreguntas, 150, 45);
                doc.setLineWidth(0.3); // Establece el grosor del borde en 1 (puedes ajustarlo según sea necesario)
                doc.setDrawColor(0); // Establece el color del borde en negro (RGB: 0, 0, 0)
                doc.rect(5, RetanguloPreguntas, 145, 45); // Dibuja un rectángulo alrededor de la primera imagen

                doc.addImage(firmaFile2, 'JPEG', 150, RetanguloPreguntas, 142, 45);
                doc.setLineWidth(0.3); // Establece el grosor del borde en 1 (puedes ajustarlo según sea necesario)
                doc.setDrawColor(0); // Establece el color del borde en negro (RGB: 0, 0, 0)
                doc.rect(150, RetanguloPreguntas, 142, 45); // Dibuja un rectángulo alrededor de la primera imagen

                //-----
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
            } else if (element == 5) {
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                textoTablaPreguntas = textoTablaPreguntas + 55;
                RetanguloPreguntas = RetanguloPreguntas + 55;

                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 10;
                    RetanguloPreguntas = 5;
                }
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(50, RetanguloPreguntas, 25, 16, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Post', 51, textoTablaPreguntas + 4.5, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Produced by:', 76, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('reviewed by:', 126, textoTablaPreguntas, 'left');
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Approved by:', 176, textoTablaPreguntas, 'left');
                textoTablaPreguntas = textoTablaPreguntas + 8;
                RetanguloPreguntas = RetanguloPreguntas + 8;
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Purchasing negotiation leader', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('SGI Analyst', 126, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Supply Chain Director', 176, textoTablaPreguntas, 'left');


                textoTablaPreguntas = textoTablaPreguntas + 8;
                RetanguloPreguntas = RetanguloPreguntas + 8;
                doc.setFont('', 'bold');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(50, RetanguloPreguntas, 25, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('Date', 51, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(75, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('01-06-2023', 76, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(125, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('01-06-2023', 126, textoTablaPreguntas, 'left');
                doc.setFont('', '');
                doc.setFillColor(255, 255, 255); // Establece el color de fondo en gris claro (RGB: 245, 245, 245)
                doc.rect(175, RetanguloPreguntas, 50, 8, 'FD'); // Dibuja un rectángulo con el color de fondo
                doc.setTextColor(0, 0, 0); // Establece el color del texto en negro
                doc.text('05-06-2023', 176, textoTablaPreguntas, 'left');
                doc.setFontSize(10)
                if (RetanguloPreguntas >= 180) {
                    doc.addPage()
                    textoTablaPreguntas = 5;
                    RetanguloPreguntas = 0;
                }
            }
            doc.setFontSize(10)
            if (RetanguloPreguntas >= 180) {
                doc.addPage()
                textoTablaPreguntas = 5;
                RetanguloPreguntas = 0;
            }
        })



        /*doc.setFillColor(255, 0, 0);
        doc.rect(45, 200, 200, 210, 'FD'); // Dibuja un rectángulo con el color de fondo
    */
        const pdfData = doc.output('arraybuffer');

        // Crea un objeto Blob a partir de los datos del PDF
        const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Crea un objeto FileReader
        const reader = new FileReader();
        // Lee el contenido del Blob como una URL de datos
        reader.readAsDataURL(pdfBlob);
        // Escucha el evento "load" cuando la lectura se haya completado
        reader.onload = function () {
            // Obtiene la cadena base64 del resultado de la lectura
            const base64String = reader.result.split(',')[1];
            // Usa la cadena base64 como sea necesario (por ejemplo, enviarla al servidor, mostrarla en un elemento HTML, etc.)

            /*window.open(pdfUrl, '_blank');*/
            if (sendEmail) {
                EnviarCorreopdf(base64String, "vanessa.forero@talsa.com.co" + "," + localStorage.Email, nombreProveedor, "CALIFICACIÓN DE PROVEEDORES").then((result2) => {
                })
            }
            resolve(base64String)
        };
        /* window.open(pdfUrl, '_blank');*/
    })

}

